import { ReleaseText } from "./ReleaseText";

export default ReleaseText;
